(function() {
  'use strict';

  angular
    .module('service.quiz')
    .factory('QuizService', QuizService);

  QuizService.$inject = ['$http', 'ServiceHelper'];

  function QuizService($http, ServiceHelper) {
    var url = {
      answer: 'https://:host/:ipad/gaviota-api/trainee/cModule/:cModuleId/course/:courseId/quiz/:quizId/question/:questionId',
      submit: 'https://:host/:ipad/gaviota-api/trainee/cModule/:cModuleId/course/:courseId/quiz/:quizId'
    };

    var keys = ['ipad', 'cModuleId', 'courseId', 'quizId', 'questionId'];

    function createUrl(baseUrl, data) {
      return keys.reduce(function(url, key) {
        return url.replace(new RegExp('/:' + key), '');
      }, Object.keys(data).reduce(function(url, key) {
        var value = data[key]
        return url.replace(new RegExp('/:' + key), value ? '/' + data[key] : '');
      }, baseUrl));
    }

    function respond(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return ServiceHelper.errorHandler(errorCb || angular.noop)(response);
      });
    }

    var service = {
      answerQuestion: answerQuestion,
      submitQuiz: submitQuiz
    };

    return service;

    function answerQuestion(params, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: params.cModuleId,
        courseId: params.courseId,
        quizId: params.quizId,
        questionId: params.questionId
      });

      return ServiceHelper.checkCanCallService(function() {
        return respond($http.post(createUrl(url.answer, urlParams), params),
          resultCb, errorCb);
      });
    }

    function submitQuiz(params, resultCb, errorCb) {
      params.outroFrameId = params.outroFrameID;
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: params.cModuleId,
        courseId: params.courseId,
        quizId: params.quizId
      });

      return ServiceHelper.checkCanCallService(function() {
        return respond($http.post(createUrl(url.submit, urlParams), _.omit(params, 'cModuleId', 'quizId', 'courseId', 'outroFrameID')), resultCb, errorCb);
      });
    }
  }
})();
